import { IonFab, IonFabButton, IonIcon } from '@ionic/react'
import { arrowUpCircle } from 'ionicons/icons'
import React, { BaseSyntheticEvent } from 'react'

interface IScrollprops {
  record?: Record<string, never>
  isHorizontalEnd?: boolean
}

const ScrollToTopButton: React.FC<IScrollprops> = (scrollProps) => {
  const { isHorizontalEnd } = scrollProps

  const scrollToTop = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    const content: HTMLIonContentElement | null = document.querySelector(':not(.ion-page-hidden) > ion-content')
    content?.scrollToTop(500)
  }

  return (
    <IonFab vertical='bottom' horizontal={isHorizontalEnd ? 'end' : 'start'} slot='fixed'>
      <IonFabButton onClick={scrollToTop}>
        <IonIcon icon={arrowUpCircle} />
      </IonFabButton>
    </IonFab>
  )
}

export default ScrollToTopButton
